<template>
	<div>
		<v-flex>
			<v-card class="mt-4">
				<v-card-title class="mb-3">
					<h2>Status konkursu: {{getContestStatus(contestStatus)}}</h2>
					<v-spacer/>
				</v-card-title>
				<div v-if="contestStatus === 'NEW'">
					<v-btn class="ml-3" @click="publish" color="default">
						Opublikuj
					</v-btn>
				</div>
				<div v-if="contestStatus === 'ANNOUNCEMENT_UNDONE'">
					<div>
						<v-btn class="ml-3" @click="publish" color="default">
							Opublikuj
						</v-btn>
					</div>
					<div>
						<v-btn class="ml-3" @click="initialRejectionAndCommitteeAssign" color="default">
							Rozpocznij wstępne odrzucenie i przydział do komisji
						</v-btn>
					</div>
				</div>
				<div class="ml-3" v-if="contestStatus === 'ANNOUNCED'">
					<div>
						<v-btn class="ml-3" @click="initialRejectionAndCommitteeAssign" color="default">
							Rozpocznij wstępne odrzucenie i przydział do komisji
						</v-btn>
					</div>
					<div>
						<v-btn class="ml-3" @click="unPublish" color="default">
							Cofnij publikację
						</v-btn>
					</div>
				</div>
				<div v-if="contestStatus === 'INITIAL_REJECTION_AND_COMMITTEE_ASSIGN'">
					<div>
						<v-btn class="ml-3" @click="startEvaluation" color="default">
							Rozpocznij ocenianie
						</v-btn>
					</div>
					<div>
						<v-btn class="ml-3 white--text" @click="undoInitialRejectionAndCommitteeAssign" color="default">
							Cofnij
						</v-btn>
					</div>
				</div>
				<div v-if="contestStatus === 'EVALUATION'">
					<div>
						<v-btn  class="ml-3" @click="startFinalEvaluation" color="default">
							Rozpocznij opiniowanie końcowe i generowanie projektów
						</v-btn>
					</div>
					<div>
						<v-btn class="ml-3 white--text" @click="undoEvaluation" color="default">
							Cofnij
						</v-btn>
					</div>
				</div>
				<div v-if="contestStatus === 'FINAL_EVALUATION'">
					<div>
						<v-btn class="ml-3" @click="undoFinalEvaluation" color="default">
							Cofnij
						</v-btn>
					</div>
				</div>
				<div v-if="contestStatus === 'FINAL_EVALUATION'">
					<div>
						<v-btn class="ml-3" @click="finishContestDialog.show = true" color="default">
							Zakończ konkurs
						</v-btn>
					</div>
				</div>
				<div>
					<v-btn class="ml-3" v-if="contestStatus ==='FINISHED'"
						@click="allowFinalEvaluationPreview" color="primary">
						Udostępnij oferentom kartę opinii końcowej
					</v-btn>
				</div>
			</v-card>
		</v-flex>

		<egranty-error-list-popup
			title="Nie udało się opublikować konkursu:"
			:error-list="announcementErrors.messages"
			:is-open="announcementErrors.showPopup"
			@close="closeAnnouncementErrorsPopup"
		/>

		<egranty-error-list-popup
			title="Nie udało się rozpocząć wstępnego odrzucania:"
			:error-list="initialRejectionErrors.messages"
			:is-open="initialRejectionErrors.showPopup"
			@close="closeInitialRejectionErrorsPopup"
		/>

		<egranty-error-list-popup
			title="Nie udało się rozpocząć oceniania:"
			:error-list="evaluationStartErrors.messages"
			:is-open="evaluationStartErrors.showPopup"
			@close="closeEvaluationStartErrorsPopup"
		/>

		<egranty-error-list-popup
			title="Nie udało się rozpocząć opiniowania końcowego:"
			:error-list="finalEvaluationErrors.messages"
			:is-open="finalEvaluationErrors.showPopup"
			@close="closeFinalEvaluationErrorsPopup"
		/>

		<egranty-error-list-popup
			title="Nie udało się udostępnić możliwości wykonywania oceny przebiegu współpracy:"
			:error-list="collaborationEvaluationPermissionErrors.messages"
			:is-open="collaborationEvaluationPermissionErrors.showPopup"
			@close="closeCollaborationEvaluationPermissionErrorsPopup"
		/>

		<v-dialog v-model="finishContestDialog.show" persistent width="500">
			<v-form ref="form">
				<v-card>
					<v-card-title class="headline">Kończenie konkursu</v-card-title>
					<div style="margin: 20px">
						Aby zakończyć konkurs, podaj link do strony z wynikami.
					</div>
					<egranty-text-input-field style="margin: 20px"
						label="Adres strony z wynikami"
						v-model="finishContestDialog.value"
						:validation-rules="[emailNotEmptyRule]"/>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat @click="finishContestDialog.show = false">Anuluj</v-btn>
						<v-btn flat @click="finishContest">Zakończ konkurs</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
	</div>
</template>

<script>
	import {PublicContest} from "@/api/generated/PublicContest";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import {Api} from "@/api";
	import EgrantyTextInputField from "../../../genericComponents/EgrantyTextInputField";

	export default {

		name: "ContestActionView",
		components: {EgrantyTextInputField, EgrantyErrorListPopup},
		data() {
			return {
				contestStatus: null,
				collaborationEvaluationFormIncluded: false,
				announcementErrors: {
					showPopup: false,
					messages: [],
				},
				finalEvaluationErrors: {
					showPopup: false,
					messages: [],
				},
				initialRejectionErrors: {
					showPopup: false,
					messages: [],
				},
				evaluationStartErrors: {
					showPopup: false,
					messages: [],
				},
				finishContestDialog: {
					show: false,
					value: ""
				},
				collaborationEvaluationPermissionErrors: {
					showPopup: false,
					value: ""
				}
			};
		},

		created() {
			this.refresh();
		},

		methods: {

			allowFinalEvaluationPreview() {
				this.$confirm("Czy na pewno chcesz udostępnić karty wszystkim oferentom?", {
					color: "blue",
					icon: "warning",
					title: "Udostępnienie kart ocen",
					width: 600,
				}).then(response => {
					if (response){
						PublicContest.putFinalEvaluationPreview(this, this.$route.params.id, successResponse => {
							this.$messagesBus.$emit("success", "Karty zostały udostępnione wszystkim oferentom!", successResponse);
						}, errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się udostępnic kart!", errorResponse);
						});
					}
				});
			},

			emailNotEmptyRule () {
				if (this.finishContestDialog.value === "") {
					return "Adres strony jest wymagany";
				} else {
					return true;
				}
			},

			refresh() {
				PublicContest.getStatus(this, this.$route.params.id, response => {
					this.contestStatus = response.contestStatus;
				});
				PublicContest.getCollaborationEvaluationPermissionData(this, this.$route.params.id, response => {
					this.collaborationEvaluationFormIncluded = response.collaborationEvaluationFormIncluded;
				});
			},

			finishContest () {
				if (!this.$refs.form.validate()) {
					return;
				}
				PublicContest.postFinish(this, this.$route.params.id, this.finishContestDialog.value,
					() => {
						this.finishContestDialog = {show: false, value: ""};
						this.refresh();
						this.$messagesBus.$emit("success", "Konkurs został zakończony");
					},
					errorResponse => {
						this.finishContestDialog = {show: false, value: ""};
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
					});
			},

			undoEvaluation() {
				PublicContest.putStartEvaluation(this, this.$route.params.id, () => {
					this.$messagesBus.$emit("success", "Ocena została cofnięta");
					this.refresh();
				});
			},

			async startEvaluation() {
				let path = "/public-contest/all-forms?contestId=" + this.$route.params.id;
				let confirmationMessage;
				await Api.syncGet(this, path, successResponse => {
					confirmationMessage = this.generateEvaluationConfirmationMessage(successResponse.contestSchemaSet);
					this.$confirm(confirmationMessage, {
						color: "blue",
						icon: "warning",
						title: "Rozpoczęcie oceniania",
						width: 600,
					})
						.then(response => {
							if (response) {
								PublicContest.postStartEvaluation(this, this.$route.params.id, successResponse => {
									this.$messagesBus.$emit("success", "Ocena została rozpoczęta", successResponse);
									this.refresh();
								}, errorResponse => {
									this.evaluationStartErrors.messages = errorResponse.message.split("\n");
									this.evaluationStartErrors.messages.pop();
									this.evaluationStartErrors.showPopup = true;
									this.$messagesBus.$emit("error", "Nie udało się rozpocząć oceny", this.snackbarMessage + " " + JSON.stringify(errorResponse));
								});
							}
						});
				});
			},

			startFinalEvaluation() {
				PublicContest.postFinalEvaluation(this, this.$route.params.id, () => {
					this.$messagesBus.$emit("success", "Rozpoczęte zostały opinie końcowe");
					this.refresh();
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się rozpocząć!", this.snackbarMessage + " " + JSON.stringify(errorResponse));
					this.finalEvaluationErrors.messages = errorResponse.message.split("\n");
					this.finalEvaluationErrors.messages.pop();
					this.finalEvaluationErrors.showPopup = true;
				});
			},

			undoFinalEvaluation () {
				PublicContest.putFinalEvaluation(this, this.$route.params.id,
					() => {
						this.$messagesBus.$emit("success", "Opinia końcowa została cofnięta");
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się cofnąć!", this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});
			},

			undoInitialRejectionAndCommitteeAssign() {
				PublicContest.putInitialRejection(this, this.$route.params.id,
					() => {
						this.$messagesBus.$emit("success", "Wstępne odrzucanie ofert zostało cofnięte");
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się cofnąć!", this.snackbarMessage + " " + JSON.stringify(errorResponse));
						this.announcementErrors.messages = errorResponse.message.split("\n");
						this.announcementErrors.messages.pop();
						this.announcementErrors.showPopup = true;
					});
			},

			initialRejectionAndCommitteeAssign() {
				PublicContest.postInitialRejection(this, this.$route.params.id,
					() => {
						this.$messagesBus.$emit("success", "Wstępne odrzucanie ofert zostało rozpoczęte");
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie rozpocząć wstępne odrzucanie ofert", this.snackbarMessage + " " + JSON.stringify(errorResponse));
						this.initialRejectionErrors.messages = errorResponse.message.split("\n");
						this.initialRejectionErrors.messages.pop();
						this.initialRejectionErrors.showPopup = true;
					});
			},

			publish() {
				PublicContest.postAnnounce(this, this.$route.params.id,
					() => {
						this.$messagesBus.$emit("success", "Konkurs został opublikowany");
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie opublikować konkursu", this.snackbarMessage + " " + JSON.stringify(errorResponse));
						this.announcementErrors.messages = errorResponse.message.split("\n");
						this.announcementErrors.messages.pop();
						this.announcementErrors.showPopup = true;
					});
			},

			unPublish() {
				PublicContest.postSuppress(this, this.$route.params.id,
					successResponse => {
						this.$messagesBus.$emit("success", "Publikacja została cofnięta", this.snackbarMessage + " " + JSON.stringify(successResponse));
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się wycofać publikacji", this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});
			},

			getContestStatus(status) {
				if (status === "NEW") {
					return "Nowy";
				}
				if (status === "ANNOUNCED") {
					return "Opublikowany";
				}
				if (status === "ANNOUNCEMENT_UNDONE") {
					return "Publikacja cofnięta";
				}
				if (status === "INITIAL_REJECTION_AND_COMMITTEE_ASSIGN") {
					return "Wstępne odrzucenie i przydział do komisji";
				}
				if (status === "EVALUATION") {
					return "Ocena";
				}
				if (status === "FINAL_EVALUATION") {
					return "Opinie końcowe i generowanie projektów";
				}
				if (status === "FINISHED") {
					return "Konkurs zakończony";
				}
			},

			generateEvaluationConfirmationMessage(schemaSet) {
				let message = "Oceny i opinie zawarte w konkursie: ";
				let schemasIncluded = [];
				if (schemaSet.formalEvaluationSchemaIncluded) {
					schemasIncluded.push("opinia formalna");
				}
				if (schemaSet.individualEvaluationSchemaIncluded) {
					schemasIncluded.push("indywidualna opinia członka komisji");
				}
				if (schemaSet.agencyEvaluationSchemaIncluded) {
					schemasIncluded.push("opinia placówki");
				}
				if (schemaSet.expertEvaluationSchemaIncluded) {
					schemasIncluded.push("opinia eksperta");
				}
				if (schemaSet.committeeCollaborationEvaluationSchemaIncluded) {
					schemasIncluded.push("ocena współpracy przez komisję");
				}
				message = schemasIncluded.length === 0 ?
					message = message.concat(" brak. Rozpoczęcie oceniania w przypadku niezdefiniowanych ocen indywidualnych powoduje rozpoczęcie posiedzenia komisji") :
					message = message.concat(schemasIncluded.join(", "));
				return message.concat(". Rozpoczęcie oceny zablokuje możliwość edycji parametrów oceny. Czy na pewno chcesz rozpocząć ocenianie?");
			},

			closeAnnouncementErrorsPopup() {
				this.announcementErrors.showPopup = false;
			},

			closeInitialRejectionErrorsPopup() {
				this.initialRejectionErrors.showPopup = false;
			},

			closeEvaluationStartErrorsPopup() {
				this.evaluationStartErrors.showPopup = false;
			},

			closeFinalEvaluationErrorsPopup () {
				this.finalEvaluationErrors.showPopup = false;
			},

			closeCollaborationEvaluationPermissionErrorsPopup () {
				this.collaborationEvaluationPermissionErrors.showPopup = false;
			}
		},
	};
</script>

<style scoped>

</style>
